import React from 'react';
import { Breakpoint as BreakpointComponent } from 'react-socks';
import { observer } from 'mobx-react';

import { ComponentBase } from '../../../shared/ComponentBase.js';
import { InjectedStyledComponent } from '../../../shared/InjectedStyledComponent.js';

import { IBreakpointConfiguration, IBreakpointProps, IBreakpointState } from './models/index.js';
import { BREAKPOINT_CATEGORY_KEY, BREAKPOINT_COMPONENT_KEY } from './Breakpoint.meta.js';

export class Breakpoint extends ComponentBase<IBreakpointProps, IBreakpointState, IBreakpointConfiguration> {
	categoryKey = BREAKPOINT_CATEGORY_KEY;
	componentKey = BREAKPOINT_COMPONENT_KEY;

	constructor(props: IBreakpointProps) {
		super(props);
	}
	render() {
		const { children } = this.props;
		return <BreakpointComponent {...this.props}>{children}</BreakpointComponent>;
	}
}

export default InjectedStyledComponent(observer(Breakpoint), BREAKPOINT_CATEGORY_KEY, BREAKPOINT_COMPONENT_KEY);
